import { render, staticRenderFns } from "./salesReturnRecord.vue?vue&type=template&id=f909a6f2&scoped=true"
import script from "./salesReturnRecord.vue?vue&type=script&lang=js"
export * from "./salesReturnRecord.vue?vue&type=script&lang=js"
import style0 from "./salesReturnRecord.vue?vue&type=style&index=0&id=f909a6f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f909a6f2",
  null
  
)

export default component.exports